import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import styled from 'styled-components';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AUTO_DISMISS_TIMEOUT = 5000;
const SurveyThankYouWrapper = styled.div.withConfig({
  displayName: "EPCsatSurveyThankYou__SurveyThankYouWrapper"
})({
  height: '484px'
});
export default function EpSurveyThankYou({
  onDismiss
}) {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onDismiss();
    }, AUTO_DISMISS_TIMEOUT);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [onDismiss]);
  return /*#__PURE__*/_jsx(SurveyThankYouWrapper, {
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      children: [/*#__PURE__*/_jsx(CloseButton, {
        color: "icon-primary-disabled",
        onClick: onDismiss
      }), /*#__PURE__*/_jsx(CardSection, {
        children: /*#__PURE__*/_jsxs(TFlex, {
          align: "center",
          direction: "column",
          children: [/*#__PURE__*/_jsx(Illustration, {
            height: 240,
            name: "nps-question-thank-you",
            marginInlineEnd: "200"
          }), /*#__PURE__*/_jsx(Text, {
            as: "h4",
            textAlign: "center",
            marginBlockStart: "800",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "epAmplitudeSurvey.feedback.thankYou"
            })
          })]
        })
      })]
    })
  });
}